import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, contentChild, input } from '@angular/core';
import { MbsSize } from '../utils';
import { CardGroupComponent } from './card-group/card-group.component';

@Component({
  selector: 'mbs-card',
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  host: {
    '[style.height]': 'getHeight()'
  }
})
export class CardComponent {
  public readonly invalid = input<boolean>(false);
  public readonly innerBordered = input<boolean>(false);
  public readonly border = input<boolean>(true);
  public readonly hasPadding = input<boolean>(true);
  public readonly size = input<MbsSize.xs | MbsSize.sm | MbsSize.lg | ''>('');
  public readonly customClasses = input<string>('');
  public readonly staticHeight = input<string | number>();

  protected readonly cardGroups = contentChild(CardGroupComponent);

  protected readonly cardSize = computed<string>(() => {
    const size = this.size();

    return size ? `-${size}` : '';
  });

  protected readonly cardMainClasses = computed<string>(() => this.cardSize() + ' ' + this.customClasses());

  protected readonly getHeight = computed<string>(() => {
    const staticHeight = this.staticHeight();

    if (!staticHeight) return '';

    if (typeof staticHeight === 'number') {
      return String(staticHeight) + 'px';
    }

    return staticHeight;
  });
}
